export default __webpack_public_path__ + "static/media/besiege.d4a07026.png";